import React, { useRef, JSX, useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { SizeValue } from './sizeValue/sizeValue';
import styles from './sizeValues.scss';
import { ISalesArticleVariantSize, IVariantStore } from '../../../../types';

export const SizeValues = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const wrapperRef = useRef<HTMLDivElement>(null);

        useEffect(() => {
            if (wrapperRef.current) {
                const wrapperChildren = Array.from(wrapperRef.current.children as HTMLCollectionOf<HTMLElement>);

                let maxChildWidth = 0;
                wrapperChildren.forEach(element => {
                    if (element.clientWidth > maxChildWidth) maxChildWidth = element.offsetWidth;
                });

                wrapperRef.current.setAttribute('style', `grid-template-columns: repeat(auto-fill, ${maxChildWidth}px);`);
            }
        }, [variantStore?.selectedSizeType]);

        function renderArticleVariantSize(articleVariantSize: ISalesArticleVariantSize) {
            return (
                <SizeValue
                    size={articleVariantSize.size}
                    variantKey={articleVariantSize.salesArticleVariantKey}
                    key={articleVariantSize.size.name}
                />
            );
        }

        function renderKioskSizes(): JSX.Element {
            return (
                // <>{variantStore?.mainStore.workWearStoreStore.selectedSizeType?.sizes.map(renderArticleVariantSize)}</>
                <>{'workWearStoreStore.selectedSizeType'}</>
            );
        }

        function renderVariantStoreSizes(): JSX.Element {
            return <>{variantStore?.selectedSizeType?.sizes.map(renderArticleVariantSize)}</>;
        }

        return (
            <div ref={wrapperRef} data-testid='size_values' data-semantic-id='size_values' className={styles.size_values}>
                {variantStore?.mainStore.showKioskLayout ? renderKioskSizes() : renderVariantStoreSizes()}
            </div>
        );
    })
);

